import React, { useState, useEffect, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { User } from 'lucide-react'
import { useAuth } from '../../context/AuthContext'
import Logo from '../Logo/Logo'
import './CardNav.css'

const CardNav = ({
  items,
  baseColor = '#fff',
  menuColor = '#000',
  buttonBgColor = '#111',
  buttonTextColor = '#fff',
  ease = 'power3.out'
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const navRef = useRef(null)
  const navigate = useNavigate()
  const location = useLocation()
  const { isAuthenticated } = useAuth()

  useEffect(() => {
    if (isOpen && navRef.current) {
      // Calculate proper height including content
      const content = navRef.current.querySelector('.card-nav-content')
      if (content) {
        const contentHeight = content.scrollHeight
        const topHeight = 60
        const totalHeight = topHeight + contentHeight + 16 // 16px for padding
        navRef.current.style.height = `${totalHeight}px`
      }
    } else if (navRef.current) {
      navRef.current.style.height = '60px'
    }
  }, [isOpen])

  const handleItemClick = (path, requireAuth = false) => {
    if (requireAuth && !isAuthenticated) {
      navigate(`/login?redirect=${encodeURIComponent(path)}`)
    } else {
      navigate(path)
    }
    setIsOpen(false)
  }

  return (
    <div className="card-nav-container" dir="rtl">
      <nav 
        ref={navRef}
        className={`card-nav ${isOpen ? 'open' : ''}`}
        style={{ 
          backgroundColor: baseColor,
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)'
        }}
      >
        <div className="card-nav-top">
          <div className="logo-container">
            <Logo />
          </div>
          <button
            className={`hamburger-menu ${isOpen ? 'open' : ''}`}
            onClick={() => setIsOpen(!isOpen)}
            aria-label="תפריט"
            style={{ color: menuColor }}
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
          {isAuthenticated ? (
            <button
              className="card-nav-user-button gradient-border-pill"
              onClick={() => handleItemClick('/settings')}
              aria-label="הגדרות"
              title="הגדרות"
            >
              <span className="card-nav-user-button-inner gradient-border-pill-inner">
                <User className="w-5 h-5" />
              </span>
            </button>
          ) : (
            <button
              className="card-nav-cta-button gradient-border-pill"
              onClick={() => handleItemClick('/login')}
            >
              <span className="card-nav-cta-button-inner gradient-border-pill-inner">נסה עכשיו</span>
            </button>
          )}
        </div>
        <div className="card-nav-content">
          {items.map((item, index) => (
            <div
              key={index}
              className="nav-card"
              style={{
                backgroundColor: item.bgColor,
                color: item.textColor
              }}
              onClick={() => {
                if (item.links && item.links.length > 0) {
                  handleItemClick(item.links[0].path, item.links[0].requireAuth)
                }
              }}
            >
              <div className="nav-card-label">{item.label}</div>
              <div className="nav-card-links">
                {item.links.map((link, linkIndex) => (
                  <a
                    key={linkIndex}
                    className="nav-card-link"
                    href={link.path}
                    onClick={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      handleItemClick(link.path, link.requireAuth)
                    }}
                    style={{ color: item.textColor }}
                    aria-label={link.ariaLabel || link.label}
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      </nav>
    </div>
  )
}

export default CardNav

